import {
  POWERBI_REQUEST,
  POWERBI_SUCCESS,
  POWERBI_FAILURE,
  POWERBI_LOCATION_REQUEST,
  POWERBI_LOCATION_SUCCESS,
  POWERBI_LOCATION_FAILURE,
  POWERBIDPC_REQUEST,
  POWERBIDPC_SUCCESS,
  POWERBIDPC_FAILURE,
  POWERBIDPCMEMBERSHIP_REQUEST,
  POWERBIDPCMEMBERSHIP_SUCCESS,
  POWERBIDPCMEMBERSHIP_FAILURE,
  PATIENT_SATISFACTION_REQUEST,
  PATIENT_SATISFACTION_SUCCESS,
  PATIENT_SATISFACTION_FAILURE,
  PMD_INTERNAL_DAILY_REQUEST,
  PMD_INTERNAL_DAILY_SUCCESS,
  PMD_INTERNAL_DAILY_FAILURE,
  PMD_INTERNAL_WEEKLY_REQUEST,
  PMD_INTERNAL_WEEKLY_SUCCESS,
  PMD_INTERNAL_WEEKLY_FAILURE,
  PMD_INTERNAL_MONTHLY_REQUEST,
  PMD_INTERNAL_MONTHLY_SUCCESS,
  PMD_INTERNAL_MONTHLY_FAILURE,
  PATIENT_ADVOCATE_REQUEST,
  PATIENT_ADVOCATE_SUCCESS,
  PATIENT_ADVOCATE_FAILURE,
  HEALTHCENTER_UTILIZATION_REQUEST,
  HEALTHCENTER_UTILIZATION_SUCCESS,
  HEALTHCENTER_UTILIZATION_FAILURE,
  HEALTHCENTER_DASHBOARD_REQUEST,
  HEALTHCENTER_DASHBOARD_SUCCESS,
  HEALTHCENTER_DASHBOARD_FAILURE,
  POWERBI_COW_REQUEST,
  POWERBI_COW_SUCCESS,
  POWERBI_COW_FAILURE,
  POWERBI_SONM_REQUEST,
  POWERBI_SONM_SUCCESS,
  POWERBI_SONM_FAILURE,
  POWERBI_AC_REQUEST,
  POWERBI_AC_SUCCESS,
  POWERBI_AC_FAILURE,
  POWERBI_CONMB_REQUEST,
  POWERBI_CONMB_SUCCESS,
  POWERBI_CONMB_FAILURE,
  POWERBI_PAI_REQUEST,
  POWERBI_PAI_SUCCESS,
  POWERBI_PAI_FAILURE,
  POWERBI_PMD_DEMO_REQUEST,
  POWERBI_PMD_DEMO_SUCCESS,
  POWERBI_PMD_DEMO_FAILURE,
  EXPORT_TO_PDF_REQUEST,
  EXPORT_TO_PDF_SUCCESS,
  EXPORT_TO_PDF_FAILURE,
  PG_DASHBOARD_COW_REQUEST,
  PG_DASHBOARD_COW_SUCCESS,
  PG_DASHBOARD_COW_FAILURE,
  PG_DASHBOARD_MCCSC_REQUEST,
  PG_DASHBOARD_MCCSC_SUCCESS,
  PG_DASHBOARD_MCCSC_FAILURE,
  PG_DASHBOARD_LL_REQUEST,
  PG_DASHBOARD_LL_SUCCESS,
  PG_DASHBOARD_LL_FAILURE,
  PATIENT_INSURANCE_REQUEST,
  PATIENT_INSURANCE_SUCCESS,
  PATIENT_INSURANCE_FAILURE,
  PROVIDER_SCORECARD_REQUEST,
  PROVIDER_SCORECARD_SUCCESS,
  PROVIDER_SCORECARD_FAILURE,
  PATIENT_ELIGIBILITY_REQUEST,
  PATIENT_ELIGIBILITY_SUCCESS,
  PATIENT_ELIGIBILITY_FAILURE,
  REFERRAL_DASHBOARD_REQUEST,
  REFERRAL_DASHBOARD_SUCCESS,
  REFERRAL_DASHBOARD_FAILURE,
  GOOGLE_MAP_REQUEST,
  GOOGLE_MAP_SUCCESS,
  GOOGLE_MAP_FAILURE,
} from './PowerBiActions';

const initialState = {
  reports: {
    client: [],
    location:[],
    dpc: [],
    dpcMembership: [],
    patientSatisfaction: [],
    pmdInternalDaily: [],
    pmdInternalWeekly: [],
    pmdInternalMonthly: [],
    patientAdvocate: [],
    healthCenterUtilization: [],
    healthCenterDashboard: [],
    cowClientDashboard: [],
    sonmClientDashboard: [],
    acClientDashboard: [],
    conmbClientDashboard: [],
    paiClientReport: [],
    pmdDemoClientReport: [],
    pgDashboardCOW: [],
    pgDashboardMCCSC: [],
    pgDashboardLL: [],
    patientInsuranceReport: [],
    providerScorecard: [],
    patientEligibility: [],
    referralDashboard: [],
    googleMapReport: [],
  },
  error: null,
  isLoading: false,
};

export default function powerBiReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case POWERBI_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, client: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_LOCATION_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_LOCATION_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, location: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_LOCATION_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBIDPC_REQUEST:
      return { ...state, isLoading: true };
    case POWERBIDPC_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, dpc: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBIDPC_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBIDPCMEMBERSHIP_REQUEST:
      return { ...state, isLoading: true };
    case POWERBIDPCMEMBERSHIP_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, dpcMembership: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBIDPCMEMBERSHIP_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_SATISFACTION_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_SATISFACTION_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, patientSatisfaction: payload.data },
        error: null,
        isLoading: false,
      };
    case PATIENT_SATISFACTION_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PMD_INTERNAL_DAILY_REQUEST:
      return { ...state, isLoading: true };
    case PMD_INTERNAL_DAILY_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pmdInternalDaily: payload.data },
        error: null,
        isLoading: false,
      };
    case PMD_INTERNAL_DAILY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PMD_INTERNAL_WEEKLY_REQUEST:
      return { ...state, isLoading: true };
    case PMD_INTERNAL_WEEKLY_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pmdInternalWeekly: payload.data },
        error: null,
        isLoading: false,
      };
    case PMD_INTERNAL_WEEKLY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PMD_INTERNAL_MONTHLY_REQUEST:
      return { ...state, isLoading: true };
    case PMD_INTERNAL_MONTHLY_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pmdInternalMonthly: payload.data },
        error: null,
        isLoading: false,
      };
    case PMD_INTERNAL_MONTHLY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_ADVOCATE_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_ADVOCATE_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, patientAdvocate: payload.data },
        error: null,
        isLoading: false,
      };
    case PATIENT_ADVOCATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case HEALTHCENTER_UTILIZATION_REQUEST:
      return { ...state, isLoading: true };
    case HEALTHCENTER_UTILIZATION_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, healthCenterUtilization: payload.data },
        error: null,
        isLoading: false,
      };
    case HEALTHCENTER_UTILIZATION_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case HEALTHCENTER_DASHBOARD_REQUEST:
      return { ...state, isLoading: true };
    case HEALTHCENTER_DASHBOARD_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, healthCenterDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case HEALTHCENTER_DASHBOARD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_COW_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_COW_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, cowClientDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_COW_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_SONM_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_SONM_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, sonmClientDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_SONM_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_AC_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_AC_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, acClientDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_AC_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_CONMB_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_CONMB_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, conmbClientDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_CONMB_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_PAI_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_PAI_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, paiClientReport: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_PAI_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case POWERBI_PMD_DEMO_REQUEST:
      return { ...state, isLoading: true };
    case POWERBI_PMD_DEMO_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pmdDemoClientReport: payload.data },
        error: null,
        isLoading: false,
      };
    case POWERBI_PMD_DEMO_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case EXPORT_TO_PDF_REQUEST:
      return { ...state, isFileDownloading: true };
    case EXPORT_TO_PDF_SUCCESS:
      return { ...state, isFileDownloading: false };
    case EXPORT_TO_PDF_FAILURE:
      return { ...state, isFileDownloading: false };

    case PG_DASHBOARD_COW_REQUEST:
      return { ...state, isLoading: true };
    case PG_DASHBOARD_COW_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pgDashboardCOW: payload.data },
        error: null,
        isLoading: false,
      };
    case PG_DASHBOARD_COW_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PG_DASHBOARD_MCCSC_REQUEST:
      return { ...state, isLoading: true };
    case PG_DASHBOARD_MCCSC_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pgDashboardMCCSC: payload.data },
        error: null,
        isLoading: false,
      };
    case PG_DASHBOARD_MCCSC_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PG_DASHBOARD_LL_REQUEST:
      return { ...state, isLoading: true };
    case PG_DASHBOARD_LL_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, pgDashboardLL: payload.data },
        error: null,
        isLoading: false,
      };
    case PG_DASHBOARD_LL_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_INSURANCE_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_INSURANCE_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, patientInsuranceReport: payload.data },
        error: null,
        isLoading: false,
      };
    case PATIENT_INSURANCE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PROVIDER_SCORECARD_REQUEST:
      return { ...state, isLoading: true };
    case PROVIDER_SCORECARD_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, providerScorecard: payload.data },
        error: null,
        isLoading: false,
      };
    case PROVIDER_SCORECARD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_ELIGIBILITY_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, patientEligibility: payload.data },
        error: null,
        isLoading: false,
      };
    case PATIENT_ELIGIBILITY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case REFERRAL_DASHBOARD_REQUEST:
      return { ...state, isLoading: true };
    case REFERRAL_DASHBOARD_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, referralDashboard: payload.data },
        error: null,
        isLoading: false,
      };
    case REFERRAL_DASHBOARD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case GOOGLE_MAP_REQUEST:
      return { ...state, isLoading: true };
    case GOOGLE_MAP_SUCCESS:
      return {
        ...state,
        reports: { ...state.reports, googleMapReport: payload.data },
        error: null,
        isLoading: false,
      };
    case GOOGLE_MAP_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/power-bi/PowerBiReducer.js